import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const InstagramIcon = ({width}) => { 
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "instagram.png" }) {
        childImageSharp {
          fluid(maxWidth: 800, , quality: 10) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
 
  return (
    <div style={{width: `${width}px`}}>
      <a href='https://www.instagram.com/canborneo.id/' target='_blank' rel="noopener noreferrer">
        <Img fluid={data.placeholderImage.childImageSharp.fluid} />
      </a>
    </div>
  )
}

export default InstagramIcon
